import { RewardModalWrapper } from '@/components/reward-modal-wrapper';
import { CloseIcon } from '@/components/svg-icons';
import { useReward } from '@/contexts/reward-context';
import { VoucherType } from '@/types';
import { extractDateParts } from '@/utils/date';
const formatExpireDate = (expireDate: string) => {
	const { year, month, day, hours, minutes, seconds } = extractDateParts(expireDate);
	return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}(GMT-4)`;
};
export const NotUsed = () => {
	const {
		onGoToLeague,		
		onClose,
		labels,
		notUsedVoucherData,
		setNotUsedVoucherData,
		setOddsBoostParticipantsNotify,
		onKafkaSet,
	} = useReward();

	const formatedExpireDate = notUsedVoucherData?.ExpireDate &&  formatExpireDate(notUsedVoucherData?.ExpireDate) || notUsedVoucherData?.ExpireDate;
	const handleClose = () => {
		onKafkaSet({
			type: 9,
			action: 12
		});
		setNotUsedVoucherData(undefined);
		setOddsBoostParticipantsNotify();
		onClose();
	};

	const useVoucher = async () => {
		onKafkaSet({
			type: 9,
			action: 13
		});
		if (!notUsedVoucherData) return;
		try {
			switch (notUsedVoucherData?.VoucherType) {
				case VoucherType.FreeOddsBooster:
					await onGoToLeague?.({ sport: 1, leagueId: [3] });
					break;
				case VoucherType.AffPromotionOddsBoost:
					await onGoToLeague?.({ sport: 1, leagueId: [3, 4, 5, 8, 43] });
					break;
			}
			setNotUsedVoucherData(undefined);
			setOddsBoostParticipantsNotify();
			onClose();
		} catch (error) {
			console.error(error);
		}
	};
	return (
		<RewardModalWrapper>
			<div className="reward-not-used">
				<div className="reward-not-used__bg"></div>   
				<div
					className="reward-not-used__close"
					onClick={handleClose}
				>
					<CloseIcon />
				</div>
				<div className="reward-not-used__title">{labels?.lbl_oddspromopop01}</div>
				<div className="reward-not-used__subtitle">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19">
						<path fill="currentColor" fillRule="evenodd" d="M9.198.502a9 9 0 1 0 2.597 17.554.844.844 0 0 0-.524-1.605 7.313 7.313 0 1 1 4.496-9.726.844.844 0 0 0 1.561-.64A9 9 0 0 0 9.198.502Zm.647 4.217a.844.844 0 0 0-1.688 0V9.15L5.87 11.438a.843.843 0 1 0 1.192 1.193l2.536-2.535.248-.247v-5.13Zm7.03 12.656a1.125 1.125 0 1 1-2.249 0 1.125 1.125 0 0 1 2.25 0Zm-.28-7.031a.843.843 0 1 0-1.688 0v3.937a.844.844 0 0 0 1.688 0v-3.937Z" clipRule="evenodd" />
					</svg>
					<span>
						{formatedExpireDate}
					</span>
				</div>
				<div className="reward-not-used__voucher"></div>    
				<div className="reward-receive__btn" onClick={useVoucher}>
					<button className="reward-btn-3d " type="button" data-animate="false">
						<span className="reward-btn-3d__text">{labels?.lbl_oddspromopop02}</span>  
						<div className="reward-btn-3d__bg"></div>                      
					</button> 
				</div>
				<div className="reward-not-used__close">
				</div>   
			</div>
		</RewardModalWrapper>
	);
};